import React from 'react';
import { Helmet } from 'react-helmet';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { Portfolio } from './components/Portfolio';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { FullPortfolio } from './pages/FullPortfolio';
function HomePage() {
  return <>
      <Header data-id="element-0" />
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <About data-id="element-3" />
        <Services data-id="element-4" />
        <Portfolio data-id="element-5" />
        <Contact data-id="element-6" />
      </main>
      <Footer data-id="element-7" />
    </>;
}
export function App() {
  // Structured Data for LocalBusiness
  const localBusinessSchema = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Moonstone Events',
    description: "Full-service wedding planning in the San Francisco Bay Area, creating timeless celebrations that reflect each couple's unique story.",
    url: 'https://moonstoneevents.com',
    email: 'hello@moonstoneevents.com',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'San Francisco Bay Area',
      addressRegion: 'CA',
      addressCountry: 'US'
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: '37.7749',
      longitude: '-122.4194'
    },
    areaServed: {
      '@type': 'GeoCircle',
      geoMidpoint: {
        '@type': 'GeoCoordinates',
        latitude: '37.7749',
        longitude: '-122.4194'
      },
      geoRadius: '50000'
    },
    priceRange: '$$-$$$',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rUQF6Uf2VmBJQJzUwZbaDt/pasted-image.jpg',
    sameAs: ['https://www.instagram.com/moonstone__events']
  };
  // Structured Data for Services
  const servicesSchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: 'Wedding Planning',
    provider: {
      '@type': 'LocalBusiness',
      name: 'Moonstone Events'
    },
    areaServed: {
      '@type': 'State',
      name: 'California'
    },
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Wedding Planning Services',
      itemListElement: [{
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Full Service Wedding Planning',
          description: 'Comprehensive support from start to finish, handling every detail from vendor management to design vision and day-of coordination.'
        }
      }, {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Partial Wedding Planning',
          description: 'Support for couples who have booked their venue and need help securing remaining vendors, refining design details, and managing the final months.'
        }
      }, {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Event Management',
          description: 'Day-of coordination for couples who have planned their wedding and need a professional to execute their vision seamlessly.'
        }
      }]
    }
  };
  // Structured Data for Organization
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Moonstone Events',
    url: 'https://moonstoneevents.com',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rUQF6Uf2VmBJQJzUwZbaDt/pasted-image.jpg',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'hello@moonstoneevents.com',
      contactType: 'Customer Service',
      areaServed: 'US'
    },
    founder: {
      '@type': 'Person',
      name: 'Annie Zhu',
      jobTitle: 'Wedding Planner'
    }
  };
  return <BrowserRouter data-id="element-8">
      <div className="font-sans" data-id="element-9">
        <Helmet data-id="element-10">
          <title data-id="element-11">Moonstone Events | Bay Area Wedding Planning & Design</title>
          <meta name="description" content="Full-service wedding planning in the San Francisco Bay Area. From intimate ceremonies to grand celebrations, we bring your vision to life with artistry, care, and intention." data-id="element-12" />
          <meta name="keywords" content="wedding planner, bay area wedding, san francisco wedding planner, full service wedding planning, event management, wedding coordinator" data-id="element-13" />

          {/* Open Graph Tags */}
          <meta property="og:title" content="Moonstone Events | Bay Area Wedding Planning & Design" data-id="element-14" />
          <meta property="og:description" content="Full-service wedding planning in the San Francisco Bay Area. From intimate ceremonies to grand celebrations, we bring your vision to life with artistry, care, and intention." data-id="element-15" />
          <meta property="og:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/rUQF6Uf2VmBJQJzUwZbaDt/pasted-image.jpg" data-id="element-16" />
          <meta property="og:url" content="https://moonstoneevents.com" data-id="element-17" />
          <meta property="og:type" content="website" data-id="element-18" />

          {/* Twitter Card Tags */}
          <meta name="twitter:card" content="summary_large_image" data-id="element-19" />
          <meta name="twitter:title" content="Moonstone Events | Bay Area Wedding Planning & Design" data-id="element-20" />
          <meta name="twitter:description" content="Full-service wedding planning in the San Francisco Bay Area. From intimate ceremonies to grand celebrations, we bring your vision to life with artistry, care, and intention." data-id="element-21" />
          <meta name="twitter:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/rUQF6Uf2VmBJQJzUwZbaDt/pasted-image.jpg" data-id="element-22" />

          {/* Structured Data - LocalBusiness */}
          <script type="application/ld+json" data-id="element-23">
            {JSON.stringify(localBusinessSchema)}
          </script>

          {/* Structured Data - Services */}
          <script type="application/ld+json" data-id="element-24">
            {JSON.stringify(servicesSchema)}
          </script>

          {/* Structured Data - Organization */}
          <script type="application/ld+json" data-id="element-25">
            {JSON.stringify(organizationSchema)}
          </script>
        </Helmet>

        <Routes data-id="element-26">
          <Route path="/" element={<HomePage data-id="element-28" />} data-id="element-27" />
          <Route path="/portfolio" element={<FullPortfolio data-id="element-30" />} data-id="element-29" />
        </Routes>
      </div>
    </BrowserRouter>;
}